import { render, staticRenderFns } from "./DecimalInput.vue?vue&type=template&id=b1629b36&scoped=true&"
import script from "./DecimalInput.vue?vue&type=script&lang=js&"
export * from "./DecimalInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1629b36",
  null
  
)

export default component.exports